import { createContext } from 'react';
import { User } from '@/types/auth';

export interface AuthContextType {
  user: User | undefined;
  loading: boolean;
  error: Error | null;
  login: (
    email: string,
    next?: string
  ) => Promise<{ success: boolean; message: string; magic_link?: string }>;
  loginWithGoogle: (next?: string) => Promise<void>;
  verifyMagicLink: (
    token: string
  ) => Promise<{ success: boolean; user?: User; message?: string }>;
  verifyOTP: (
    email: string,
    code: string
  ) => Promise<{ success: boolean; user?: User; message?: string }>;
  logout: () => Promise<void>;
  refreshToken: () => Promise<boolean>;
  clearAuth: () => void;
  isAuthenticated: boolean;
  hasPermission: (permissionName: string) => boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
